import React from 'react'

import { LeavingGuard } from '@components/utils/LeavingGuard'
import {
  Button,
  Fieldset,
  HeadContent,
  Loading,
  Select,
  Subsection,
  Table,
} from '@fourthwall/components'
import { ConfirmBar } from '@modules/Dashboard/modules/ConfirmBar'
import { routing } from '@utils/routing'

import { BadgesSkeleton } from './BadgesSkeleton'
import { useBadgesContext } from './hooks/useBadgesContext'
import { BadgesProvider } from './providers/BadgesProvider'
import { FormFields } from './providers/BadgesProvider/types'

const BadgesContent = () => {
  const badges = useBadgesContext()

  if (badges.isFetching) return <BadgesSkeleton />

  return (
    <>
      <HeadContent title="Badges" />
      <Subsection
        title="Badges"
        rightContent={
          <Button
            label="Create a new badge"
            appearance="primary"
            size="small"
            to={routing.memberships.settings.badges.create}
          />
        }
      >
        <Table {...badges.table} isLoading={badges.isLoading} />
      </Subsection>
      <Subsection title="Number of badges to show in comments">
        <Fieldset>
          <Fieldset.Row>
            Control the maximum number of badges that show up next to a member’s name in the
            comments.
          </Fieldset.Row>
          <Fieldset.Row>
            <Loading isLoading={badges.isLoading}>
              <div style={{ width: '100%' }}>
                <Select
                  label="Number of badges"
                  {...badges.form.getFieldProps(FormFields.uncollapsedBadgesCount)}
                  value={badges.form.values[FormFields.uncollapsedBadgesCount]}
                  options={[
                    {
                      label: '1 (recommended for label badges)',
                      value: '1',
                      key: '1',
                    },
                    {
                      label: '2',
                      value: '2',
                      key: '2',
                    },
                    {
                      label: '3 (recommended for minimal badges)',
                      value: '3',
                      key: '3',
                    },
                    {
                      label: '4',
                      value: '4',
                      key: '4',
                    },
                    {
                      label: '5',
                      value: '5',
                      key: '5',
                    },
                  ]}
                />
              </div>
            </Loading>
          </Fieldset.Row>
        </Fieldset>
      </Subsection>
      <ConfirmBar
        isOpen={badges.form.dirty}
        isLoading={badges.isLoading}
        onConfirm={badges.form.submitForm}
        onCancel={badges.form.resetForm}
      />
      <LeavingGuard
        when={badges.form.dirty}
        isValid={badges.form.isValid}
        onSave={badges.form.submitForm}
      />
    </>
  )
}

export const Badges = () => (
  <BadgesProvider>
    <BadgesContent />
  </BadgesProvider>
)
